import React from 'react';
import type { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import Checkbox from 'atom-components/form-fields-for-hook-form/checkbox';

type Props = {
  canEditMark: boolean;
};

export default function FlagForAttention({ canEditMark }: Props): ReactElement {
  const { control, setValue } = useFormContext();

  const inputName = 'flagForAttention';

  return (
    <div>
      <Checkbox role="checkbox">
        <Checkbox.Input
          id={inputName}
          control={control}
          name={inputName}
          role="checkbox"
          disabled={!canEditMark}
          onChange={(): void => {
            // Reset the state of submitForReview each time the checkbox changes to ensure that the
            // marker reconfirms that the mark is submitted for review in the event that the flag
            // for attention checkbox is checked, they confirm send for review, flag for attention
            // is unchecked, and then checked again.
            //
            // The above is a bit of an edge case that can only currently happen when the Confirm
            // Submit for Review modal is confirmed, then the Confirm Mark Creation modal is
            // cancelled, resulting in a situation where the Submit Marking button needs to be
            // clicked again.
            setValue('submitForReview', false);
          }}
        />
        <Checkbox.Label htmlFor={inputName}>
          Flag for attention by marking coordinator
        </Checkbox.Label>
      </Checkbox>
    </div>
  );
}
